var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_vm._v(" "+_vm._s(_vm.$tc('common.comprasion', _vm.comprasionResult))+" team champion skill ")])}
var staticRenderFns = []

export { render, staticRenderFns }